import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { setGlobalSetting } from '../../reducer/utilitySlice';

const GlobalSetting = () => {
  const dispatch = useDispatch();
  const {
    utilityData: { globalSetting },
  } = useSelector((state) => state);

  useQuery([{}, `/v6/api/pms/getglobalsettings`, {}, {}], {
    retry: false,
    enabled: !globalSetting,
    onSuccess: ({ data: resData }) => {
      dispatch(setGlobalSetting(resData?.response));
    },
  });

  return null;
};

export default GlobalSetting;
